"use client"
import { createContext, useContext, useMemo, useState } from 'react';

export type TenantContextValue = {
    tenant: string | undefined;
};
const TenantContext = createContext<TenantContextValue | undefined>(undefined);

export const useTenant = () => useContext(TenantContext);

export const TenantProvider = ({
    children,
}: {
    children: React.ReactNode,
}) => {
    const [tenant, setTenant] = useState(); // default theme


    return (
        <TenantContext.Provider value={{ tenant }}>
            {children}
        </TenantContext.Provider>
    );
};